import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex)`
  width: 100%;
  padding: 16px;
  cursor: pointer;
  &.checked {
    background: #f4f9ec;
  }
`;

export const StyledField = styled(Flex)`
  flex: 1;
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.antd?.colorTextSecondary};
  .label {
    font-weight: 500;
    color: ${(props) => props.theme.antd?.colorTextHeading};
  }
`;

export const DeleteButton = styled.div`
  padding: 12px;
  cursor: pointer;
  font-size: 18px;
  color: #999;
  :hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
